<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-modal v-model="modal" :title="banderaFlujo != 6 ? 'Preparación' : 'Preparación a clínica'" centered size="lg">
      <div>
        <p style="font-weight: 600">¿Enviar el paquete a recolección?</p>
      </div>
      <div slot="modal-footer">
        <b-button
          style="margin-right: 40px"
          variant="outline-primary"
          :disabled="loaderAcciones"
          @click="enviar()"
        >
          <span v-if="!loaderAcciones">Aceptar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="loaderAcciones"
          @click="modal = false"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import { LaboratorioService } from "../../apiServices/laboratorio/LaboratorioService";

export default {
  name: "preparacion",
  components: {},
  props: {
    parametros: null,
    banderaFlujo: null,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      modal: true,
      laboratorioServicio: new LaboratorioService(),
      idSolicitud: null,
      idEtapa: null,
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idSolicitud = this.parametros[0].idSolicitud;
    this.idEtapa = this.parametros[0].idEtapa;
  },
  methods: {
    enviar() {
      this.laboratorioServicio
        .enviarRecepcion(this.idSolicitud, this.idEtapa)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Se registro correctamente",
            showConfirmButton: false,
          });
          // this.$v.$reset()
          location.reload();
        });
    },
  },
};
</script>

<style scoped></style>
